/*
 *
 * ResetPassword constants
 *
 */

export const DEFAULT_ACTION = 'app/ResetPassword/DEFAULT_ACTION';

export const VALIDATE_RESET_TOKEN = `${DEFAULT_ACTION}/VALIDATE_RESET_TOKEN`;
export const UPDATE_LINK_EXPIRED = `${DEFAULT_ACTION}/UPDATE_LINK_EXPIRED`;
export const RESET_PASSWORD = `${DEFAULT_ACTION}/RESET_PASSWORD`;

export const VALIDATE_RESET_TOKEN_URL = {
  url: '/common/user/password/reset-token/validate',
  method: 'POST',
};

export const RESET_PASSWORD_URL = {
  url: '/common/user/password',
  method: 'PATCH',
};
